// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"4":"07dd57f4","174":"8e43ba6e","188":"9971249c","255":"d73f0f5e","319":"6bbafd4b","566":"fb624e39","767":"bf2ca6f2","842":"3f47aacb","878":"fed03b67"}[chunkId] + ".js";
};